// services/useTheme.js
import { useState, useEffect } from "react";

export function useTheme() {
  const [isDarkTheme, setIsDarkTheme] = useState(
    () => localStorage.getItem("theme") === "dark",
  );

  useEffect(() => {
    // Handler for local storage changes across tabs
    const handleStorageChange = () => {
      setIsDarkTheme(localStorage.getItem("theme") === "dark");
    };

    // Custom event handler for immediate changes in the same tab
    const handleLocalThemeChange = () => {
      setIsDarkTheme(localStorage.getItem("theme") === "dark");
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("themeChanged", handleLocalThemeChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("themeChanged", handleLocalThemeChange);
    };
  }, []);

  return isDarkTheme;
}
